import React, { useState } from 'react'; //フック
import Form from 'react-bootstrap/Form'; //Bootstrapコンポーネント

const DaysBtn = () => {
  const [val, setVal] = useState("日前");
  const handleChenge = e => setVal(e.target.value);
      return (
        <div className="inputNumWrap">
          <p>経過日数</p>
          <input type="text" id="inputNum" />
          <Form id="radioWrap">
            <div className="mb-1">
              <Form.Check inline label="日前" value="日前" name="radio" type="radio" id="radio01" checked={val === "日前"} onChange={handleChenge} />
              <Form.Check inline label="年前" value="年前" name="radio" type="radio" id="radio02" checked={val === "年前"} onChange={handleChenge} />
              <Form.Check inline label="日後" value="日後" name="radio" type="radio" id="radio03" checked={val === "日後"} onChange={handleChenge} />
              <Form.Check inline label="年後" value="年後" name="radio" type="radio" id="radio04" checked={val === "年後"} onChange={handleChenge} />
            </div>
          </Form>
        </div>
      )
  return val;
}

export default DaysBtn;